
import { PermissionAccordionProps, PermissionItem } from "./interface";
import CheckboxDropdown from "../CheckboxDropdown"
import "./style.scss";

const extractAllPermCodes = (permissions: PermissionItem[] | undefined): string[] => {
  const result: string[] = [];

  // Recursive helper function to walk through each permission item
  const traverse = (items: PermissionItem[]) => {
    // Safety check to prevent runtime errors
    if (!Array.isArray(items)) return;

    for (const item of items) {
      // Collect the current item's perm_code
      result.push(item.perm_code);
      // Recursively process children, if they exist
      if (Array.isArray(item.child) && item.child.length > 0) {
        traverse(item.child);
      }
    }
  };

  // Kick off the recursion with provided permissions
  traverse(permissions || []);
  return result;
};



const PermissionAccordion: React.FC<PermissionAccordionProps> = ({
  permissionLabel,
  handleStorePermissionToggle,
  storeID,
  structuredPermission,
  defaultPermission,
  _handleCheckboxChange,
  isChecked
}):JSX.Element => {
  const allPermission = extractAllPermCodes(structuredPermission)
  return (
    <div className="member-permission p-2">
      <div className="d-flex flex-wrap align-items-center gap-3">
        <label className="fs-18 fw-600 permissionToggleLabel">
          <input
            type="checkbox"
            className="permissionToggleCheckbox me-2 my-2"
            checked={isChecked}
            onChange={() => handleStorePermissionToggle(storeID, !isChecked)}
          />
          {permissionLabel}
        </label>
      </div>
      {isChecked && <div className=" mt-2">
        <CheckboxDropdown
          structuredPermission={structuredPermission}
          handleCheckboxChange={(codeArr: []) => _handleCheckboxChange(codeArr)}
          defaultPermission={defaultPermission}
          allPermission={allPermission}
        />
      </div>}
    </div>
  );
};

export default PermissionAccordion;
